import React from 'react';
import { motion } from 'framer-motion';
export function SevenDayPlan() {
  const days = [{
    day: 1,
    title: 'Descubrimiento con IA',
    desc: 'Encuentra tu nicho rentable en 5 minutos usando nuestros prompts maestros.'
  }, {
    day: 2,
    title: 'Estructura Inteligente',
    desc: 'Deja que la IA cree el índice perfecto y los capítulos de tu guía.'
  }, {
    day: 3,
    title: 'Redacción Mágica',
    desc: 'La IA redacta el contenido completo por ti. Tú solo revisas y apruebas.'
  }, {
    day: 4,
    title: 'Diseño Pro en Segundos',
    desc: 'Usa herramientas de IA para que tu PDF se vea premium sin ser diseñadora.'
  }, {
    day: 5,
    title: 'Empaque de tu Activo',
    desc: 'Descarga tu producto listo para recibir pagos.'
  }, {
    day: 6,
    title: "Kit de Ventas 'Copy-Paste'",
    desc: 'Usa nuestros guiones de Instagram y WhatsApp para atraer clientes.'
  }, {
    day: 7,
    title: '¡Lanzamiento Express!',
    desc: 'Tu negocio en línea funcionando y listo para tus primeros $6.36.'
  }];
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-187">
      <div className="max-w-3xl mx-auto" data-id="element-188">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-189">
          <span className="text-primary font-bold uppercase tracking-wider text-sm mb-2 block" data-id="element-190">
            Tu Mapa de Ruta
          </span>
          <h2 className="text-3xl md:text-5xl text-dark font-display font-extrabold tracking-headline" data-id="element-191">
            El Plan Exacto de 7 Días
          </h2>
          <p className="text-xl text-slate-500 mt-4 font-medium" data-id="element-192">
            (Diseñado para mamás ocupadas)
          </p>
        </motion.div>

        <div className="relative" data-id="element-193">
          {/* Vertical Line */}
          <div className="absolute left-8 md:left-1/2 top-0 bottom-0 w-0.5 bg-slate-200 md:-translate-x-1/2" data-id="element-194"></div>

          <div className="space-y-8 relative z-10" data-id="element-195">
            {days.map((item, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className={`flex flex-col md:flex-row items-start md:items-center gap-6 ${idx % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-196">
                {/* Content */}
                <div className={`flex-1 w-full pl-20 md:pl-0 ${idx % 2 === 0 ? 'md:text-left' : 'md:text-right'}`} data-id="element-197">
                  <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-198">
                    <h3 className="text-xl font-bold text-dark mb-2" data-id="element-199">
                      {item.title}
                    </h3>
                    <p className="text-slate-600" data-id="element-200">{item.desc}</p>
                  </div>
                </div>

                {/* Number Badge */}
                <div className="absolute left-0 md:relative md:left-auto flex-shrink-0 w-16 h-16 rounded-full bg-primary text-white flex items-center justify-center font-display font-bold text-2xl shadow-lg border-4 border-white z-10" data-id="element-201">
                  Día {item.day}
                </div>

                {/* Empty space for alternating layout */}
                <div className="flex-1 hidden md:block" data-id="element-202"></div>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-16 text-center" data-id="element-203">
          <p className="text-2xl font-display font-bold text-dark mb-6" data-id="element-204">
            No necesitas perfección.{' '}
            <span className="text-primary" data-id="element-205">Necesitas terminar.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}